var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "steps-container justify-content-md-around",
      class: { "mb-0": _vm.step === 4 },
    },
    [
      _c("i", {
        staticClass: "far fa-angle-left d-block d-md-none",
        class: { "step-1": _vm.step == 1, "mr-1": _vm.step > 1 },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "step",
          class: {
            "step-active": _vm.step == 1,
            "d-none": _vm.step != 1,
            "d-md-block": _vm.step != 1,
          },
        },
        [
          _vm.step > 1
            ? _c("span", [_c("i", { staticClass: "far fa-check-circle" })])
            : _c("span", { staticClass: "step-count" }, [_vm._v("1")]),
          _vm._v(" "),
          _c("span", [_vm._v("Your membership")]),
        ]
      ),
      _vm._v(" "),
      _vm.step == 1
        ? _c("i", { staticClass: "far fa-angle-right d-block d-md-none" })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "step-dash d-none d-md-block" }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "step",
          class: {
            "step-active": _vm.step == 2,
            "d-none": _vm.step != 2,
            "d-md-block": _vm.step != 2,
          },
        },
        [
          _vm.step > 2
            ? _c("span", [_c("i", { staticClass: "far fa-check-circle" })])
            : _c("span", { staticClass: "step-count" }, [_vm._v("2")]),
          _vm._v(" "),
          _c("span", [_vm._v("Your donation")]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "step-dash d-none d-md-block" }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "step",
          class: {
            "step-active": _vm.step == 3,
            "d-none": _vm.step != 3,
            "d-md-block": _vm.step != 3,
          },
        },
        [
          _vm.step > 3
            ? _c("span", [_c("i", { staticClass: "far fa-check-circle" })])
            : _c("span", { staticClass: "step-count" }, [_vm._v("3")]),
          _vm._v(" "),
          _c("span", [_vm._v("Confirm your details")]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "step-dash d-none d-md-block" }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "step",
          class: {
            "step-active": _vm.step == 4,
            "d-none": _vm.step != 4,
            "d-md-block": _vm.step != 4,
          },
        },
        [
          _vm.step > 4
            ? _c("span", [_c("i", { staticClass: "far fa-check-circle" })])
            : _c("span", { staticClass: "step-count" }, [_vm._v("4")]),
          _vm._v(" "),
          _c("span", [_vm._v("Payment")]),
        ]
      ),
      _vm._v(" "),
      _vm.step > 1
        ? _c("i", { staticClass: "far fa-angle-right d-block d-md-none" })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }